/**
 * @file Whether a published edition's re-check of open schedules is still
 * running: its cursor is unfinished (`done < total`) and the server's
 * `running` flag is set. Derived from stored state only, never from a clock,
 * so a mounted screen moves from running to stopped on the snapshot that
 * clears the flag. A stopped cursor no longer holds Approve (the approval
 * claim re-checks for itself) and S4 offers to resume it. Pure and shared:
 * S1's Re-checking rows (`scheduleRecheckEdition`), `RecheckProgress` and the
 * edition's Waiting on.
 */
import type { PricebookRecheckProgress } from './System.Pricebook.types';

export function pricebookRecheckRunning(recheck: Pick<PricebookRecheckProgress, 'total' | 'done' | 'running'>): boolean {
    return recheck.done < recheck.total && recheck.running;
}
